/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const ReviewGroupsContainer = styled.p`
  border-top: 1px solid ${token('color.border', colors.N40A)};
`;
